import { Platform, Orientation } from "consts";

export const ContainerWidth = {
  [Platform.WEB]: {
    [Orientation.PORTRAIT]: "60%",
    [Orientation.LANDSCAPE]: "55%",
  },
  [Platform.TAB]: {
    [Orientation.LANDSCAPE]: "92%",
  },
};

export const ButtonHeight = {
  [Platform.TAB]: {
    [Orientation.LANDSCAPE]: "190",
    [Orientation.PORTRAIT]: "180",
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "130",
  },
};

export const ButtonMarginBottom = {
  [Platform.AND]: {
    [Orientation.PORTRAIT]: " 0px 10px 20px 10px",
  },
};

export const ListTextFontWeight = {
  [Platform.AND]: {
    [Orientation.LANDSCAPE]: "800",
    [Orientation.PORTRAIT]: "800",
  },
};

export const ListTextFontSize = {
  [Platform.TAB]: {
    [Orientation.LANDSCAPE]: "22",
    [Orientation.PORTRAIT]: "22",
  },
};

export const FeedbackButtonWidth = {
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "140",
    [Orientation.LANDSCAPE]: "140",
  },
};
